import { extend } from 'swiper/esm/utils/utils'

export default {
  name: 'app-active-class',

  create: function create() {
    const swiper = this
    extend(swiper, {
      appActiveClass: {
        updateClass() {
          // Set custom active class, because last slide not getting active
          // when 'slidePerView' set to 'auto'.
          // https://github.com/nolimits4web/swiper/issues/3108
          const realActiveIndex = swiper.snapGrid.indexOf(
            Math.abs(swiper.translate)
          )
          swiper.updateActiveIndex(realActiveIndex)
          swiper.slides.removeClass('active')
          swiper.slides[realActiveIndex] &&
            swiper.slides[realActiveIndex].classList.add('active')
        },
      },
    })
  },

  on: {
    init: (swiper) => swiper.appActiveClass.updateClass(),
    update: (swiper) => swiper.appActiveClass.updateClass(),
    transitionStart: (swiper) => swiper.appActiveClass.updateClass(),
  },
}
